import Axios from "@app/api/axios";

const getTentativeDetails = (payload) =>
  Axios.post("/invoices/tentative-details", payload).then(
    (response) => response.data,
  );

export default getTentativeDetails;
